import { SubAreaContentByPhase } from "../contentManager/SubAreaContentByPhase";
import "./Drivers.scss";


export const Drivers = () => {
    return <div className="drivers-container">
        <h2>3. Praxisraum</h2>
        <SubAreaContentByPhase area="practical" />
    </div>;
};